export const GET_DICTIONARY_CITY_EAGERS = Symbol('GET_DICTIONARY_CITY_EAGERS');
export const GET_DICTIONARY_CITY_EAGERS_REQUEST = Symbol('GET_DICTIONARY_CITY_EAGERS_REQUEST');
export const GET_DICTIONARY_CITY_EAGERS_SUCCESS = Symbol('GET_DICTIONARY_CITY_EAGERS_SUCCESS');
export const GET_DICTIONARY_CITY_EAGERS_ERROR = Symbol('GET_DICTIONARY_CITY_EAGERS_ERROR');

